module.exports = __webpack_public_path__ + "img/高通10.d3509dde.png";